<template lang="html">
    <div class="welcome">

        <top-nav></top-nav>

        <div class="welcome-hero">
            <div class="welcome-hero-block">
                <h1>{{getText('home_title')}}</h1>
                <div v-if="!factories.length">
                    <router-link :to="{ name: 'site' }">
                        <el-button class="greenButton">{{getText('home_button')}}</el-button>
                    </router-link>
                </div>
                <div v-else>
                    <router-link :to="{ name: 'site' }">
                        <el-button class="greenButton siteButton">{{getText('site_default_title')}}</el-button>
                    </router-link>

                    <router-link :to="{ name: 'sites' }">
                        <el-button class="greenButton sitesButton">{{getText('my_sites')}}</el-button>
                    </router-link>
                </div>

            </div>
        </div>
        <div class="container">
            <el-row class="benefits" :gutter="24">
                <el-col
                    :xs="24"
                    :md="8"
                    v-for="(benefit, index) in getTextArray('home_list_object_title')"
                    :key="index"
                >
                    <benefit-block
                        :title="getTitle(index)"
                        :content="getContent(index)"
                        :icon="getIcon(index)"
                    ></benefit-block>
                </el-col>
            </el-row>
        </div>

        <welcome-video
            :title="getText('home_youtube_title')"
            :description="getText('home_youtube_description')"
            :youtube="video.youtubeId"
        ></welcome-video>

        <page-footer></page-footer>

    </div>
</template>

<script>
import topNav from '../ui/top-nav.vue';
import pageFooter from '../ui/page-footer.vue';
import benefitBlock from './welcome-benefit-block.vue';
import welcomeVideo from './welcome-video.vue';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            video: {
                youtubeId: 'Le_WwMqZiBU',
            },
            icons: ['green-earth', 'tri', 'reports']
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'factories'
        ]),
    },
    methods: {
        getTitle (index) {
            return this.getText('home_list_object_title', index);
        },
        getContent (index) {
            return this.getText('home_list_object_description', index);
        },
        getIcon (index) {
            return this.icons[index];
        }
    },
    components: {
        topNav,
        pageFooter,
        benefitBlock,
        welcomeVideo,
        // componentLoader
    }
};
</script>

<style lang="less">
@import '../../less/variables';

.welcome {
    .welcome-hero {
        height: 600px;
        background-image: url('/static/img/viveco.jpg');
        background-size: cover;
        background-position: 50% 50%;
        display: block;
        .welcome-hero-block {
            display: block;
            padding: 18px 24px;
            text-align: center;
            width: 100%;
            color: @color-text;
            text-align: center;
            h1 {
                display: block;
                color: @color-text;
                font-weight: 200;
                text-transform: uppercase;
                font-size: 30px;
                line-height: 30px;
                margin-bottom: 120px;
                opacity: .7;
                @media @desktop {
                    margin-top: 50px;
                }
            }
            .el-button {
                margin-top: 200px;
                @media @desktop {
                    margin-top: 250px;
                }
            }
            .siteButton {
                margin-right: 20px;
            }
            .sitesButton {
                margin-left: 20px;
            }
        }
    }
    .benefits {
        .welcome-benefit-content {
            text-align: center;
            width: 80%;
            margin: auto;
            @media @desktop {
                text-align: left;
                width: 100%;
                margin: 0;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/welcome.vue